import styled from 'styled-components';
export const CoHostTooltipWrapper = styled.div.withConfig({
  displayName: "CoHostTooltipstyle__CoHostTooltipWrapper",
  componentId: "sc-19awm6r-0"
})(["position:relative;height:inherit;"]);